export default "/images/estadao.svg?d72d97f9f95ad10253389a467d818221";